import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowLeft, Mail } from "lucide-react";

/**
 * Shown instead of the RFP wizard when the agency hasn't set up its sending
 * address yet.
 *
 * An RFP exists to be emailed to carriers, and it goes out from the agency's own
 * address — a carrier has to recognise who is asking, and their reply has to
 * reach the broker. There is no fallback sender, so there is no point letting
 * someone pick a client, build a census and fill five parameter forms first.
 */
export function RfpEmailSetupRequired({ onBack }: { onBack: () => void }) {
  return (
    <div className="flex items-center justify-center py-16 px-4">
      <Card className="max-w-lg w-full">
        <CardContent className="p-8 text-center">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-blue-100 dark:bg-blue-950/50 mb-5">
            <Mail className="h-7 w-7 text-blue-600 dark:text-blue-400" />
          </div>

          <h2 className="text-xl font-semibold mb-2">Set up your email sending first</h2>
          <p className="text-sm text-muted-foreground mb-6">
            An RFP is an email to carriers, sent from your agency's own address so they know who is
            asking and their reply comes back to you. Setting it up takes a few minutes and only
            needs doing once.
          </p>

          <div className="flex flex-col sm:flex-row gap-2 justify-center">
            <Button asChild>
              <Link href="/settings?tab=email">
                <Mail className="h-4 w-4 mr-2" />
                Set up email sending
              </Link>
            </Button>
            <Button variant="outline" onClick={onBack}>
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to quotes
            </Button>
          </div>

          <p className="text-xs text-muted-foreground mt-6">
            Building a regular quote doesn't need this — only RFPs, which are emailed out.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
